import {
  GET_ACTIVITY,
  GET_ACTIVITY_SUCCESS,
  GET_ACTIVITY_BY_ID,
  GET_ACTIVITY_BY_ID_SUCCESS,
  POST_ACTIVITY,
  POST_ACTIVITY_SUCCESS,
  PATCH_ACTIVITY_BY_ID,
  PATCH_ACTIVITY_BY_ID_SUCCESS,
  DELETE_ACTIVITY_BY_ID,
  DELETE_ACTIVITY_BY_ID_SUCCESS,
} from './constants'
// GET
export function getActivityAction(payload) {
  return {
    type: GET_ACTIVITY,
    payload: payload
  }
}

export function getActivitySuccess(payload) {
  return {
    type: GET_ACTIVITY_SUCCESS,
    payload: payload
  }
}

export function getActivityByIdAction(payload) {
  return {
    type: GET_ACTIVITY_BY_ID,
    payload: payload
  }
}

export function getActivityByIdSuccess(payload) {
  return {
    type: GET_ACTIVITY_BY_ID_SUCCESS,
    payload: payload
  }
}
// POST
export function postActivityAction(payload) {
  return {
    type: POST_ACTIVITY,
    payload: payload
  }
}

export function postActivitySuccess(payload) {
  return {
    type: POST_ACTIVITY_SUCCESS,
    payload: payload
  }
}
// PATCH
export function patchActivityByIdAction(payload) {
  return {
    type: PATCH_ACTIVITY_BY_ID,
    payload: payload
  }
}

export function patchActivityByIdSuccess(payload) {
  return {
    type: PATCH_ACTIVITY_BY_ID_SUCCESS,
    payload: payload
  }
}
// DELETE
export function deleteActivityByIdAction(payload) {
  return {
    type: DELETE_ACTIVITY_BY_ID,
    payload: payload
  }
}

export function deleteActivityByIdSuccess(payload) {
  return {
    type: DELETE_ACTIVITY_BY_ID_SUCCESS,
    payload: payload
  }
}
